import {NodeParamChunk} from "../../chunks/types/NodeParamChunk";
import {getVarValueFromVarAssignmentChunk} from "./getVarValueFromVarAssignmentChunk";

export function getParamValueFromNodeParamChunk(
  nodeParamChunk: NodeParamChunk
): string {
  const {captures: {1: varAssignmentChunk}} = nodeParamChunk;
  return getVarValueFromVarAssignmentChunk(varAssignmentChunk);
}
